import CardNumberWithCopyButton from '@/common/components/CardNumberWithCopyButton'
import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { formatCurrency, formatDateTime, formatUnit } from '@/common/utils/formatters'
import { transformToNumber } from '@/common/utils/transformers'
import { FailedConsumptionDetails } from '@/features/failedConsumptions/components/failedConsumptionDetails'
import { ConsumptionData } from '@/features/failedConsumptions/types/consumption.type'
import { FailedConsumptionTableItem } from '@/features/failedConsumptions/types/failedConsumption.type'
import { UserRoundIcon } from 'lucide-react'
import React from 'react'

export class FailedConsumptionsTransformer {
  static tableTransformer(): (events: ConsumptionData[]) => FailedConsumptionTableItem[] {
    return (events) => {
      return events.map((event) => {
        const totalAmount = transformToNumber({ value: event.total_amount })

        return {
          protocol_number: event.protocol_number,
          eventable_type: eventableTypeTranslations['Client::Consumption'],
          details: React.createElement(FailedConsumptionDetails, { data: event }),
          total_amount: Number.isNaN(totalAmount) ? '--' : formatCurrency(totalAmount),
          branch: event?.client_branch?.display_name || '--',
          card: event.card ? <CardNumberWithCopyButton card={event.card} /> : '',
          usage_declaration: event.current_equipment_usage
            ? formatUnit(event.current_equipment_usage, event.current_equipment_usage_unit)
            : '--',
          capture_method: event.capture_method?.display_name || '',
          created_at: formatDateTime(new Date(event.created_at)),
          license_plate: event?.card?.equipment_field_for_display_value || '',
          buyer: (
            <div className="flex items-center gap-[10px]">
              <ImageWithPlaceholder
                url={event.buyer?.profile_picture?.url}
                alt={event.buyer?.full_name}
                className="size-6"
                iconClassName="size-4"
                placeholderIcon={UserRoundIcon}
              />
              <p>{event.buyer?.full_name}</p>
            </div>
          ),
        }
      })
    }
  }
}

const eventableTypeTranslations: { [key: string]: string } = {
  'Client::Consumption': 'Consumo',
  'Billing::Refund': 'Estorno',
}
